import { ErrorLogComponent } from '@cian/error-log-component';
import { getLogger } from '@cian/logger/browser';
import { getHttpApi } from '@cian/http-api/browser';

import * as React from 'react';
import { hydrate } from 'react-dom';

export const initializeBottomMenu = async () => {
  const adaptiveHeader = document.getElementById('adaptive-header');
  const logger = getLogger();
  const httpApi = getHttpApi();

  const bottomMenuData = window.__header_bottom_menu_data;

  if (bottomMenuData && !bottomMenuData.isStatic && bottomMenuData.newHeaderEnabled) {
    const { BottomMenu } = await import('../../../shared/components/BottomMenu');

    hydrate(
      <ErrorLogComponent logger={logger}>
        <BottomMenu {...bottomMenuData} httpApi={httpApi} />
      </ErrorLogComponent>,
      adaptiveHeader,
    );
  }
};
